/* =====================================================================
   SCRIPT MIXTE v3 — EasySell COD Fix
   
   FIX PRÉCIS du bug quantité 1 :
   Le problème était que syncFormWithOffer() cherchait offer-selected='true'
   dans le DOM APRÈS un clic sur le clone, mais EasySell ne pose pas cet
   attribut sur le bundle 1 tant qu'il n'a pas été cliqué explicitement
   dans la modal. La solution : garder une variable JS trackant la quantité
   courante côté clone, indépendamment de offer-selected.
   ===================================================================== */

(function () {
  'use strict';

  /* ─── DÉTECTION DE PAGE ─── */
  var IS_HOME2 = window.location.pathname.indexOf('home-2') !== -1;
  var IS_HOME3 = window.location.pathname.indexOf('home-3') !== -1;
  var IS_HOME1 = !IS_HOME2 && !IS_HOME3;

  /* ─── CONFIG conditionnelle home1 / home2 / home3 ─── */
  var PRICE_UNIT, IMG_URL, MIN_QTY, MAX_QTY, DISCOUNTS;

  if (IS_HOME1) {
    /* ─── CONFIG formulaire home1 ─── */
    PRICE_UNIT = 4800;
    IMG_URL    = "https://cdn.shopify.com/s/files/1/0706/6818/9775/files/b.png?v=1777735870&width=40";
    MIN_QTY    = 1;
    MAX_QTY    = 3;
    DISCOUNTS  = { 1: "-10%", 2: "-20%", 3: "-30%" };

  } else if (IS_HOME2) {
    /* ─── CONFIG formulaire home2 ─── */
    PRICE_UNIT = 4800;
    IMG_URL    = "https://cdn.shopify.com/s/files/1/0706/6818/9775/files/f6.png?v=1777742643&width=40";
    MIN_QTY    = 1;
    MAX_QTY    = 3;
    DISCOUNTS  = { 1: "-15%", 2: "-25%", 3: "-35%" };

  } else {
    /* ─── CONFIG formulaire home3 (page index) ─── */
    PRICE_UNIT = 4800;
    IMG_URL    = "https://cdn.shopify.com/s/files/1/0706/6818/9775/files/b3.png?v=1777736405&width=40";
    MIN_QTY    = 1;
    MAX_QTY    = 3;
    DISCOUNTS  = { 1: "-15%", 2: "-25%", 3: "-35%" };
  }

  /* ─── ÉTAT CENTRAL ───
     currentQty est la SOURCE DE VÉRITÉ unique.
     On ne se fie PLUS à offer-selected pour déterminer la quantité.
  ─── */
  var currentQty = 2; // défaut bundle 2

  /* ─────────────────────────────────────────────────────────────
     PARTIE A — INJECTION DU CLONE (script1 original, intact)
  ───────────────────────────────────────────────────────────────*/
  var MAX_WAIT = 12000;
  var elapsed  = 0;
  var INTERVAL = 150;

  var timer = setInterval(function () {
    elapsed += INTERVAL;

    var centerBouton   = document.querySelector('span.center-bouton');
    var originalOffers = findOriginalOffers();

    if (centerBouton && centerBouton.querySelector('.es-qty-offers-clone')) {
      clearInterval(timer);
      return;
    }

    if (!centerBouton || !originalOffers) {
      if (elapsed >= MAX_WAIT) {
        clearInterval(timer);
        console.warn('[EasySell Fix] Timeout');
      }
      return;
    }

    clearInterval(timer);

    var clone = originalOffers.cloneNode(true);
    clone.classList.add('es-qty-offers-clone');
    clone.removeAttribute('id');
    clone.style.cssText =
      'display:block!important;visibility:visible!important;' +
      'opacity:1!important;height:auto!important;' +
      'pointer-events:auto!important;position:relative!important;' +
      'top:auto!important;left:auto!important;width:100%!important;margin:0!important;';

    var atcBtn = centerBouton.querySelector('.es-popup-button');
    atcBtn
      ? centerBouton.insertBefore(clone, atcBtn)
      : centerBouton.insertBefore(clone, centerBouton.firstChild);

    if (!document.getElementById('es-fix-style')) {
      var s = document.createElement('style');
      s.id = 'es-fix-style';
      s.textContent =
        '.es-qty-offers-clone,.es-qty-offers-clone *{visibility:visible!important;opacity:1!important;}' +
        '.es-qty-offers-clone [style*="display: none"]{display:block!important;}' +
        'span.center-bouton{display:grid !important;}';
      document.head.appendChild(s);
    }

    syncCloneFromOriginal();
    initAllListeners(clone, originalOffers);
    console.log('[EasySell Fix] ✅ Bundles injectés');

  }, INTERVAL);

  /* ─────────────────────────────────────────────────────────────
     UTILITAIRES
  ───────────────────────────────────────────────────────────────*/

  function findOriginalOffers() {
    return (
      document.querySelector('#easysell-modal .es-quantity-offers') ||
      document.querySelector('.es-modal .es-quantity-offers') ||
      document.querySelector('#easysell-embedded-offers .es-quantity-offers')
    );
  }

  function findOriginalContainers() {
    var parent = findOriginalOffers();
    return parent ? parent.querySelectorAll('.es-qo-container') : [];
  }

  function updateImages(imageContainer, qty) {
    imageContainer.innerHTML = '';
    for (var i = 0; i < qty; i++) {
      var img = document.createElement('img');
      img.src = IMG_URL; img.width = 55; img.height = 55;
      img.style.cssText = 'position:relative;left:0;z-index:9999999;';
      imageContainer.appendChild(img);
    }
  }

  /* ─────────────────────────────────────────────────────────────
     SYNC CLONE ← ORIGINAL (visuel uniquement)
  ───────────────────────────────────────────────────────────────*/

  function syncCloneFromOriginal() {
    var origContainers  = findOriginalContainers();
    var clone = document.querySelector('.es-qty-offers-clone');
    if (!clone) return;
    var cloneContainers = clone.querySelectorAll('.es-qo-container');

    origContainers.forEach(function (orig, i) {
      if (!cloneContainers[i]) return;
      var sel = orig.getAttribute('offer-selected');
      sel
        ? cloneContainers[i].setAttribute('offer-selected', sel)
        : cloneContainers[i].removeAttribute('offer-selected');
      cloneContainers[i].style.cssText =
        orig.style.cssText + ';visibility:visible!important;opacity:1!important;pointer-events:auto!important;';
    });
  }

  function syncRadioButtons(idx) {
    ['radio1','radio2','radio3'].forEach(function (cls, i) {
      var r = document.querySelector('.' + cls);
      if (r) r.checked = (i === idx);
    });
  }

  /* ─────────────────────────────────────────────────────────────
     ACTION CENTRALE — sélectionner une offre par quantité
     
     C'est ici le fix principal :
     - On stocke la quantité dans currentQty (variable JS fiable)
     - On clique l'offre EasySell originale par INDEX (pas par prix)
       → index 0 = qté 1, index 1 = qté 2, index 2 = qté 3
     - On ne dépend PLUS de offer-selected pour calculer la quantité
  ───────────────────────────────────────────────────────────────*/

  function selectOfferByQty(qty, fromForm) {
    qty = Math.max(MIN_QTY, Math.min(qty, MAX_QTY));
    currentQty = qty;
    var idx = qty - 1; // index 0-basé

    /* Cliquer l'offre originale EasySell (dans la modal) */
    var origContainers = findOriginalContainers();
    if (origContainers[idx]) {
      origContainers[idx].click();
    }

    /* Sync radio buttons custom */
    syncRadioButtons(idx);

    /* Sync clone visuel après réaction Vue.js */
    setTimeout(syncCloneFromOriginal, 80);

    /* Mettre à jour le formulaire SI déjà ouvert */
    if (fromForm) {
      updateFormDisplay(qty);
    } else {
      setTimeout(function () { updateFormDisplay(qty); }, 150);
    }
  }

  /* ─────────────────────────────────────────────────────────────
     FORMULAIRE — affichage quantité + images
  ───────────────────────────────────────────────────────────────*/

  function updateFormDisplay(qty) {
    var qd  = document.querySelector('.quantity-display');
    var pd  = document.querySelector('.percentage-display');
    var ic  = document.querySelector('.image-container-formulaire');
    if (qd) qd.textContent = qty;
    if (pd) pd.textContent = ' ' + (DISCOUNTS[qty] || '');
    if (ic) updateImages(ic, qty);
  }

  var formBuilt = false;

  function buildFormControls() {
    if (formBuilt) {
      /* Formulaire déjà construit : juste mettre à jour l'affichage */
      updateFormDisplay(currentQty);
      return;
    }

    var formElement =
      document.querySelector('#easysell.es-css .p-1') ||
      document.querySelector('.es-css .p-1') ||
      document.querySelector('.p-1');
    if (!formElement) return;

    /* Nettoyage des éventuels anciens éléments */
    formElement.querySelectorAll('.quantité-globale').forEach(function(el) { el.remove(); });
    formElement.querySelectorAll('.percentage-display').forEach(function(el) { el.remove(); });

    /* Création des éléments */
    var qtyGlobal = document.createElement('div');
    qtyGlobal.className = 'd-flex justify-content-between py-1 quantité-globale';

    var labelTitle = document.createElement('div');
    labelTitle.className = 'fw-normal label-title';
    labelTitle.textContent = 'Ilość';

    var labelValue = document.createElement('div');
    labelValue.className = 'label-value';

    var qtyControls = document.createElement('div');
    qtyControls.className = 'quantity-controls es-quantity-control';

    var minusBtn = document.createElement('button');
    minusBtn.textContent = '-';
    minusBtn.className = 'quantity-button minus es-qty-btn';
    minusBtn.setAttribute('type', 'button');

    var displayWrapper = document.createElement('div');
    displayWrapper.className = 'display-wrapper';

    var qtyDisplay = document.createElement('span');
    qtyDisplay.className = 'quantity-display es-qty-display';
    qtyDisplay.textContent = currentQty; /* ← utilise currentQty, pas offer-selected */

    var pctDisplay = document.createElement('span');
    pctDisplay.className = 'percentage-display';
    pctDisplay.textContent = ' ' + (DISCOUNTS[currentQty] || '');

    var plusBtn = document.createElement('button');
    plusBtn.textContent = '+';
    plusBtn.className = 'quantity-button plus es-qty-btn';
    plusBtn.setAttribute('type', 'button');

    var imageContainer = document.createElement('div');
    imageContainer.className = 'image-container-formulaire';
    imageContainer.style.cssText =
      'display:flex;justify-content:center;position:absolute;' +
      'left:50%;transform:translateX(-50%);top:0;width:100%;z-index:1;';
    updateImages(imageContainer, currentQty);

    /* Boutons +/- : modifient currentQty et déclenchent selectOfferByQty */
    minusBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (currentQty > MIN_QTY) {
        selectOfferByQty(currentQty - 1, true);
      }
    });

    plusBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (currentQty < MAX_QTY) {
        selectOfferByQty(currentQty + 1, true);
      }
    });

    /* Assemblage */
    displayWrapper.appendChild(qtyDisplay);
    qtyControls.appendChild(minusBtn);
    qtyControls.appendChild(displayWrapper);
    qtyControls.appendChild(plusBtn);
    labelValue.appendChild(qtyControls);
    labelValue.appendChild(imageContainer);
    qtyGlobal.appendChild(labelTitle);
    qtyGlobal.appendChild(labelValue);

    var subtotalLine = formElement.querySelector('.es-subt-line');
    subtotalLine
      ? formElement.insertBefore(qtyGlobal, subtotalLine)
      : formElement.appendChild(qtyGlobal);

    var shippingLine = formElement.querySelector('.es-shipping-line');
    shippingLine
      ? formElement.insertBefore(pctDisplay, shippingLine)
      : formElement.appendChild(pctDisplay);

    /* CSS formulaire */
    if (!document.getElementById('es-form-style')) {
      var style = document.createElement('style');
      style.id = 'es-form-style';
      style.textContent =
        '.percentage-display{margin-left:10px;}' +
        '.es-css .quantité-globale{position:relative;z-index:10;}' +
        '.es-css .quantity-controls{display:flex;align-items:center;gap:5px;}' +
        '.es-css .quantity-button{background:#f0f0f0;border:1px solid #ccc;border-radius:3px;' +
          'width:25px;height:25px;display:flex;align-items:center;justify-content:center;cursor:pointer;}' +
        '.es-css .quantity-button:hover{background:#e0e0e0;}';
      document.head.appendChild(style);
    }

    formBuilt = true;
  }

  /* ─────────────────────────────────────────────────────────────
     SYNC FORMULAIRE → BUNDLES (clic dans la modal)
     Quand on clique une offre dans le formulaire ouvert,
     on lit son INDEX dans le DOM (pas son prix) → currentQty fiable
  ───────────────────────────────────────────────────────────────*/

  function onModalOfferClick(clickedContainer) {
    var origContainers = findOriginalContainers();
    var idx = -1;
    origContainers.forEach(function (c, i) {
      if (c === clickedContainer || c.contains(clickedContainer)) idx = i;
    });
    if (idx === -1) return;

    currentQty = idx + 1; /* ← index vers quantité, sans calcul par prix */
    syncRadioButtons(idx);
    setTimeout(syncCloneFromOriginal, 80);
    setTimeout(function () { updateFormDisplay(currentQty); }, 150);
  }

  /* ─────────────────────────────────────────────────────────────
     INIT — Écoute de tous les événements
  ───────────────────────────────────────────────────────────────*/
  /*nvx CSS des body bundles*/
  function initAllListeners(clone, originalOffers) {
function fixMobileWidth() {
  var offers = document.querySelector('.es-quantity-offers.es-css');
  if (!offers) return;
       if (window.innerWidth <= 1070.9) {
    offers.style.setProperty('width', '51vw', 'important'); 
    }
      if (window.innerWidth <= 960.9) {
    offers.style.setProperty('width', '446px', 'important'); 
    } 
            if (window.innerWidth <= 866.9) {
    offers.style.setProperty('width', '395px', 'important'); 
    }
           if (window.innerWidth <= 768.9) {
    offers.style.setProperty('width', '490px', 'important'); 
        offers.style.setProperty('margin-left', 'auto', 'important');
    offers.style.setProperty('margin-right', 'auto', 'important');
      offers.style.setProperty('transform', 'translate(-1px, -25px)', 'important');       
    }
             if (window.innerWidth <= 511.9) {
    offers.style.setProperty('width', '418px', 'important');        
    }
                 if (window.innerWidth <= 430.9) {
    offers.style.setProperty('width', '360px', 'important');        
    }
                     if (window.innerWidth <= 388.9) {
    offers.style.setProperty('width', '334px', 'important');        
    }
                         if (window.innerWidth <= 346.9) {
    offers.style.setProperty('width', '305px', 'important');        
    }
                            if (window.innerWidth <= 314.9) {
    offers.style.setProperty('width', '285px', 'important');        
    }
                             if (window.innerWidth <= 296.9) {
    offers.style.setProperty('width', '271px', 'important');        
    }
    if (window.innerWidth >= 960.9) {
    offers.style.setProperty('width', '500px', 'important'); 
    } 
        if (window.innerWidth >= 1182.9) {
    offers.style.setProperty('left', '22px', 'important'); 
    }
}
fixMobileWidth();
window.addEventListener('resize', fixMobileWidth);
    /* Clic sur bundle du CLONE (landing page) */
    clone.addEventListener('click', function (e) {
      var container = e.target.closest('.es-qo-container');
      if (!container) return;

      var cloneContainers = clone.querySelectorAll('.es-qo-container');
      var idx = -1;
      cloneContainers.forEach(function (c, i) {
        if (c === container || c.contains(e.target)) idx = i;
      });
      if (idx === -1) return;

      selectOfferByQty(idx + 1, false); /* idx+1 = quantité, direct, sans calcul prix */
    });

    /* Clic sur les radios custom */
    ['radio1','radio2','radio3'].forEach(function (cls, i) {
      var r = document.querySelector('.' + cls);
      if (!r) return;
      r.addEventListener('change', function () {
        if (this.checked) selectOfferByQty(i + 1, false);
      });
    });

    /* Clic sur une offre dans la MODAL EasySell */
    document.addEventListener('click', function (e) {
      var container = e.target.closest('.es-qo-container');
      if (!container) return;
      if (clone && clone.contains(container)) return; /* déjà géré ci-dessus */
      onModalOfferClick(container);
    });

    /* Bouton ATC → ouvrir formulaire avec la bonne quantité */
    document.querySelectorAll('.es-popup-button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(function () {
          buildFormControls();
          /* S'assurer que EasySell a bien sélectionné la bonne offre */
          var origContainers = findOriginalContainers();
          if (origContainers[currentQty - 1]) {
            origContainers[currentQty - 1].click();
          }
        }, 250);
      });
    });

    /* MutationObserver sur l'original pour sync visuelle clone */
    if (typeof MutationObserver !== 'undefined' && originalOffers) {
      var obs = new MutationObserver(syncCloneFromOriginal);
      obs.observe(originalOffers, {
        attributes: true, subtree: true,
        attributeFilter: ['offer-selected', 'class', 'style']
      });
    }

    /* Sélection initiale bundle 2 par défaut */
    setTimeout(function () {
      var origContainers = findOriginalContainers();
      if (origContainers.length >= 2) {
        origContainers[1].click(); /* bundle index 1 = qté 2 */
        syncRadioButtons(1);
        syncCloneFromOriginal();
      }
    }, 600);
  }

  /* ─────────────────────────────────────────────────────────────
     TRADUCTIONS (script2 original, intact)
  ───────────────────────────────────────────────────────────────*/

  (function () {
    var dictionary = {
      "Please fill in the form to order": "Proszę wypełnić formularz, aby zamówić",
      "Subtotal": "Wartość zamówienia",
      "Discount": "Rabat",
      "Shipping": "Wysyłka",
      "Free": "Darmowa",
      "Total": "Suma"
    };

    function translateElement(el) {
      el.childNodes.forEach(function (node) {
        if (node.nodeType === 3) {
          var text = node.nodeValue.trim();
          for (var key in dictionary) {
            if (text.includes(key)) node.nodeValue = node.nodeValue.replace(key, dictionary[key]);
          }
        } else if (node.nodeType === 1) {
          translateElement(node);
        }
      });
    }

    function runTranslation() {
      var sel = '.es-css label,.es-css span,.es-css b,.es-css h3,' +
        '.es-css .es-subt-line div,.es-css .es-discount-line div,' +
        '.es-css .es-shipping-line div,.es-css .es-total-line div';
      document.querySelectorAll(sel).forEach(translateElement);
    }

    runTranslation();

    var tObs = new MutationObserver(function () {
      tObs.disconnect();
      runTranslation();
      tObs.observe(document.body, { childList: true, subtree: true });
    });
    tObs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function () { setTimeout(runTranslation, 100); });
  })();

})();